import {NgModule} from '@angular/core';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {buggyRouting} from '../textile-data/buggy/buggy.routing';
import {machineTypeRouting} from './machine-type/machine-type.routing';
import {utilitiesRouting} from './utilities.routing';

@NgModule({
  imports: [TextileDataSharedModule, utilitiesRouting, buggyRouting, machineTypeRouting]
})
export class UtilitiesModule {}
